import styled, {css} from "styled-components"
import Card from "@irati/ui/src/Layout/Card"

import globalLincenses from "../../images/global_licenses.svg"

export const Banner = styled(Card)`
  ${({theme}) => css`
    display: flex;
    position: relative;
    padding: ${theme.spacing.three} ${theme.spacing.three};
    margin-bottom: ${theme.spacing.five};
    background-color: ${theme.colors.greys.lightest}
  `}
`

export const GlobalLicensesImg = styled.img.attrs({
  src: globalLincenses,
  alt: "Global Lincenses"
})``
